import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#approach", label: "Approach" },
  { href: "#services", label: "Services" },
  { href: "#transformations", label: "Transformations" },
  { href: "#founder", label: "Team" },
  { href: "#consult", label: "Consult" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F7F4EB]/75 border-b border-[#D5CEBA]/60"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-display text-2xl lg:text-3xl tracking-tight text-[#1E3A2B]">
            Aasa
          </span>
          <span className="font-display italic text-sm text-[#C25E3E] tracking-wide">
            Healthscience &amp; Nutrition
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-${l.label.toLowerCase()}-link`}
                href={l.href}
                className="nav-link text-sm uppercase tracking-[0.18em] text-[#1E3A2B]/75 hover:text-[#1E3A2B]"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#consult"
          data-testid="nav-cta-button"
          className="btn-primary hidden lg:inline-flex items-center gap-2 rounded-full bg-[#1E3A2B] text-[#FCFBF7] px-5 py-2.5 text-sm tracking-wide"
        >
          Talk to us
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#1E3A2B]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-[#D5CEBA]/60 bg-[#F7F4EB]/95 backdrop-blur-xl"
        >
          <ul className="px-6 py-6 space-y-5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  data-testid={`nav-mobile-${l.label.toLowerCase()}-link`}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block text-base uppercase tracking-[0.18em] text-[#1E3A2B]"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#consult"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-cta"
                className="inline-flex items-center gap-2 rounded-full bg-[#1E3A2B] text-[#FCFBF7] px-5 py-2.5 text-sm"
              >
                Talk to us →
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
